<template>
  <div class="flex items-center space-x-2">
    <img
      :src="getImageForService(SERVICE_APPLICATION_DATA) || undefined"
      :alt="SERVICE_APPLICATION_DATA"
      class="h-5 w-5"
      loading="lazy"
    />
    <lf-heading3>{{ $t("ORCHESTRATION.APPLICATION_DATA") }}</lf-heading3>
  </div>
</template>

<script setup lang="ts">
import { SERVICE_APPLICATION_DATA } from "@/helpers/constants";
import { getImageForService } from "@/helpers/services";

import LfHeading3 from "@/components/ui/text/LfHeading3.vue";
</script>
